import { useDebounce } from '@sbt-web/hooks';
import { TuttaItalia, GeogosClient } from '@sbt-web/networking';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { translateGeoEntry, translateGeogosResponse } from './GeogosToAutocomplete.js';

function useGeogos(hadesBasePath, channel, debounceTimeout, resultsLimit) {
    const [items, setItems] = useState([]);
    const [query, setQuery] = useState('');
    // The query can be repeatedly updated but only the debounced
    // value will ever be set, to trigger useEffect.
    const debouncedQuery = useDebounce(query, debounceTimeout);
    const updateQuery = useCallback((q = '') => {
        setQuery(q);
    }, [setQuery]);
    const client = useMemo(() => new GeogosClient(hadesBasePath, channel), [hadesBasePath, channel]);
    useEffect(() => {
        if (debouncedQuery.length >= 2) {
            client.search(debouncedQuery, { lim: resultsLimit }).then((res) => {
                setItems(translateGeogosResponse(res));
            });
        }
        else {
            setItems([]);
        }
    }, [client, debouncedQuery, resultsLimit]);
    return [items, updateQuery];
}
const defaultLocation = translateGeoEntry({
    region: TuttaItalia,
});
const mapper = {
    translateGeogosResponse,
    translateGeoEntry,
};

export { useGeogos as default, defaultLocation, mapper };
//# sourceMappingURL=useGeogos.js.map
